/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/style.scss"

// Import Swiper styles globally (once) to avoid redundant imports in each component
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"


import "./src/components/Navbar/navbar.scss"; // Navbar styles

// Import PrimeReact styles globally
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';

import React, {Suspense, lazy} from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

import { AuthProvider } from './src/services/crm/context'
const Toaster = lazy(() => import("react-hot-toast").then(mod => ({ default: mod.Toaster })));

export const wrapRootElement = ({ element }) => {
  return (
    <AuthProvider>
      <GoogleReCaptchaProvider 
        reCaptchaKey="6Lc5biIjAAAAAM72XJOuaCmVbyPh8s0b2gKWI_Aq"
        scriptProps={{
          async: true,
          defer: true,
          appendTo: "body",
        }}
        useReCaptchaNet={true}
        useEnterprise={false}
        language="en"
      >
        {element}
        <Suspense fallback={null}>
          <Toaster position="top-right" reverseOrder={true} />
        </Suspense>
      </GoogleReCaptchaProvider>
    </AuthProvider>  
  )
}

// Remove ltr/rtl classes and dir attribute from body and html
function clearDir() {
  if (typeof document === 'undefined' || !document.body) return;
  document.body.classList.remove('ltr', 'rtl');
  document.documentElement.removeAttribute('dir');
}

// Check if pathname matches a destination plan page
function isDestination(path) {
  if (!path) return false;
  const parts = path.split('/').filter(Boolean);
  const idx = parts.indexOf('plan-your-visit');
  return idx !== -1 && parts.length > idx + 1;
}

// Watch for html dir attribute and remove it if set
function watchAndClearDir() {
  if (typeof document === 'undefined' || !document.documentElement) return;
  clearDir();
  if (window.__dirObserver) window.__dirObserver.disconnect();
  const observer = new MutationObserver(() => {
    if (document.documentElement.hasAttribute('dir')) {
      document.documentElement.removeAttribute('dir');
      document.body.classList.remove('ltr', 'rtl');
    }
  });
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['dir'] });
  window.__dirObserver = observer;
}

// Schedule multiple clearDir actions unless it's a special plan page
function scheduleClearDir(path) {
  if (path && isDestination(path)) return;
  clearDir();
  requestAnimationFrame(() => {
    requestAnimationFrame(clearDir);
  });
  [100, 300, 600].forEach(t => setTimeout(clearDir, t));
}

// Gatsby: called once on client load
export const onInitialClientRender = () => {
  if (typeof window === 'undefined') return;
  const path = window.location?.pathname || '';
  const mapPage = path === '/interactive-map' || path.endsWith('/interactive-map');
  if (!mapPage) {
    scheduleClearDir(path);
    watchAndClearDir();
  }
}

// Gatsby: called on every route update
export const onRouteUpdate = ({ location }) => {
  if (typeof window === 'undefined') return;
  const path = location?.pathname || window.location?.pathname || '';
  const mapPage = path === '/interactive-map' || path.endsWith('/interactive-map');
  const lang = path.split('/')[1] || 'en';

  if (!mapPage) {
    scheduleClearDir(path);
    watchAndClearDir();
    document.body.style.overflow = 'visible';
    document.documentElement.style.overflow = 'visible';

    const font = lang === 'en' ? 'FSKoopman' : 'SBF';
    document.body.style.fontFamily = font;
    document.documentElement.style.fontFamily = font;

    document.body.style.height = 'auto';
    document.documentElement.style.height = 'auto';
  }

  if (window.jQuery) {
    initializeComponents(window.jQuery);
    return;
  }

  const loadJQuery = () => new Promise((resolve) => {
    if (window.jQuery) return resolve(window.jQuery)
    const existing = document.querySelector('script[data-dynamic="jquery"]')
    if (existing) {
      existing.addEventListener('load', () => resolve(window.jQuery))
      return
    }
    const script = document.createElement('script')
    script.src = 'https://code.jquery.com/jquery-3.6.2.min.js'
    script.integrity = 'sha256-2krYZKh//PcchRtd+H+VyyQoZ/e3EcrkxhM8ycwASPA='
    script.crossOrigin = 'anonymous'
    script.async = true
    script.defer = true
    script.dataset.dynamic = 'jquery'
    script.addEventListener('load', () => resolve(window.jQuery))
    document.body.appendChild(script)
  })

  const triggerLoad = () => {
    ['mousedown','mousemove','keypress','scroll','touchstart'].forEach((evt) =>
      document.removeEventListener(evt, triggerLoad, listenerOpts)
    )
    loadJQuery().then(($) => initializeComponents($))
  }
  const listenerOpts = { once: true, passive: true }
  ;['mousedown','mousemove','keypress','scroll','touchstart'].forEach((evt) =>
    document.addEventListener(evt, triggerLoad, listenerOpts)
  )
  setTimeout(triggerLoad, 3000)
}

function initializeComponents($) {
  function initializeCustomCollapsible() {
    if ($(".custom-collapsible").length <= 0) return
    
    $(".custom-collapsible .collapsible-header").on("click", function (event) {
        event.preventDefault();
        var $body = $(this).next(".collapsible-body");
        if ($(this).hasClass("open")) {
            $(this).removeClass("open");
            $body.removeClass("open");
        } else {
            $(".collapsible-header").removeClass("open");
            $(".collapsible-body").removeClass("open");
            $(this).addClass("open");
            $body.addClass("open");
        }
    });
      
  }
  function initializeHeader() {
    $(".header-toggle-hamburger").on("click", function () {
      $(this).addClass("open")
      $(".header-toggle-cross").addClass("open")
      $(".mobile-menu-wrapper").addClass("open")
      $("body").addClass("mobile-lock")
    })
    $(".header-toggle-cross").on("click", function () {
      $(this).removeClass("open")
      $(".header-toggle-hamburger").removeClass("open")
      $(".mobile-menu-wrapper").removeClass("open")
      $("body").removeClass("mobile-lock")
    })

    $(".menu-item").on("click", function (e) {
      if ($(this).hasClass("custom-collapsible")) {
        $(this).find(".collapsible-body a").on("click", function () {
          $(".header-toggle-cross").removeClass("open")
          $(".header-toggle-hamburger").removeClass("open")
          $(".mobile-menu-wrapper").removeClass("open")
          $("body").removeClass("mobile-lock")
        })
        $(".menu-item .collapsible-header").on("click", function (e) {
          e.stopPropagation()
        })
      }else{
        $(".header-toggle-cross").removeClass("open")
        $(".header-toggle-hamburger").removeClass("open")
        $(".mobile-menu-wrapper").removeClass("open")
        $("body").removeClass("mobile-lock")
      }
    });
    
    if($("body").hasClass("mobile-lock")){
      $("body").removeClass("mobile-lock")
    }
  }

  function handleCustomTabs() {
    if ($(".tabs").length <= 0) return
    $(".tabs li").on("click", function () {
      if ($(this).hasClass("active")) return

      $(this).siblings().removeClass("active")
      const tabs = $(this).parents(".tabs").data("controls")
      $(tabs).children().removeClass("active")

      const target = $(this).data("tab")
      const title = $(this).parents(".tabs").data("title")
      if (title != null) $(title).text($(this).text())
      $(target).addClass("active")
      $(this).addClass("active")
    })
  }
  function initializeCustomCollapsiblefaq() {
    if ($(".custom-collapsible-faq").length <= 0) return
    const $headers = $(".custom-collapsible-faq .collapsible-header-faq");
    $headers.off("click");
    $headers.on("click", function () {
        const $header = $(this);
        const body = $header.next(".collapsible-body-faq")
        const parent = $header.parent(".custom-collapsible-faq")
        if (!$header.hasClass("open")) {
          $header.addClass("open")
          $(body).css("maxHeight", $(body)[0].scrollHeight + "px")
          if ($(parent).hasClass("accordian")) {
            $(parent)
              .siblings(".custom-collapsible-faq")
              .each(function (_, collapsible) {
                $(collapsible)
                  .find(".collapsible-body-faq")
                  .css("maxHeight", "0px")
                $(collapsible)
                  .find(".collapsible-header-faq")
                  .removeClass("open")
              })
          }
        } else {
          $(body).css("maxHeight", "0px")
          $header.removeClass("open")
        }
      }
    )
    $(
      ".custom-collapsible-faq .collapsible-header-faq.open ~.collapsible-body-faq"
    ).each(function (_, body) {
      $(body).css("maxHeight", body.scrollHeight + "px")
    })
  }
  function initializeviewing() {
    const $switch = $(".switch-wrapper");
    if (!$switch.length || $switch.data("init")) return;

    $switch.data("init", true).off("click.viewing");

    const update = (active) => {
      $(".list-wrapper").toggleClass("active", active);
      $(".map-wrapper").toggleClass("active", !active);
      $(".discover").toggleClass("active", active);
      $(".list-view-text").toggleClass("active", active);
      $(".map-view-text").toggleClass("active", !active);
    };

    update($switch.hasClass("active"));

    $switch.on("click.viewing", function () {
      const active = $(this).toggleClass("active").hasClass("active");
      update(active);
    });
  }

  $(document).ready(function () {
    initializeCustomCollapsible()
    initializeHeader()
    // initializeDropdown()
    handleCustomTabs()
    initializeCustomCollapsiblefaq()
    initializeviewing()
  })
}
